import React, { useEffect, useState } from 'react';
import { DatePicker, NumberPicker, Select, Range } from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';

// 规定出所有可能的选择类型
const sectionType = [
  {
    label: '时间区间',
    key: 'RANGE',
  },
  {
    label: '相对时间',
    key: 'RELRANGE',
  },
  {
    label: '晚于',
    key: 'RANGEGT',
  },
  {
    label: '早于',
    key: 'RANGELT',
  },
];
/**
 * opType 在dayType数组范围内
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagTime = ({
  tagItem = {},
  changeData = (data) => {},
  pageType = ''
}) => {
  const [data, setData] = useState(tagItem.opValue?.extra_map ?? ['','']); // 区间的值更改前或后面的值适合用数组形式改变，所以自己内部维护一个数组
  const [type, setType] = useState(tagItem.opType ? tagItem.opType : 'RANGE'); // 枚举类型见sectionType

  /**
   * @description: 计算被禁用的时间范围
   * @param {*}
   * @return {*}
   */
  const disabledDate = (date) => {
    if(type==='RANGEGT'){
      return (date.valueOf() < moment().subtract(365,'days').valueOf() || date.valueOf() > moment().add(1,'days').valueOf()); // 最晚日期为T-1日，最早日期为距离当日365
    }else if(type==='RANGELT'){
      return (date.valueOf() < moment().subtract(364,'days').valueOf() || date.valueOf() > moment().valueOf()); // 最晚日期为当日，最早日期为距离当日364天前的日期
    }else {
      return (date.valueOf() >  moment().valueOf()); // 时间大于今天或者超出了禁用范围，不可选
    }
  };
  /**
   * @description: 改变传递的时间类型
   * @param {*} val
   * @return {*}
   */
  const changeType = (val) => {
    setType(val);
    if (val === 'RANGE') {
      setData(['', '']);
      changeData({ opValue: {label_id: tagItem?.id,extra_map:['','']}, opType: val, opDescValue: '区间' }); // opDescValue拿到所选择的所有值的中文释义
    } else if (val === 'RANGEGT' || val === 'RANGELT') {
      setData(['']);
      changeData({ opValue:{label_id: tagItem?.id,extra_map:['']} , opType: val, opDescValue:  val === 'RANGEGT' ? '晚于' : '早于' });
    } else {
      setData([0, 0]);
      changeData({ opValue: {label_id: tagItem?.id,extra_map:[0,0]}, opType: val, opDescValue: '相对区间' });
    }
  };
  /**
   * 选择早于/晚于时处理时间
   */
  const changeValue = ({ opValue, index, opType }) => {
    if (opValue) {
      const arr = [...data];
      arr[index] = opValue ? moment(opValue).format('YYYY-MM-DD') : ''
      setData(arr);
      changeData({
        opValue: {
          label_id: tagItem?.id,
          extra_map:[moment(arr[index]).format('x')],
        },
        opType: opType
      });
    } else if (!opValue) {
      const arr = [...data];
      arr[index] = '';
      setData(arr);
      changeData({
        opValue: {
          label_id: tagItem?.id,
          extra_map:arr[index],
        },
        opType: opType
      });
    }
  };
  /**
   * @description: 相对区间类型修改值
   * @param {*} v
   * @return {*}
   */
  const changeRel = (v,currentType) => {
    setData([-v[1].toString(), -v[0].toString()]);
    changeData({
      opValue: {
        label_id: tagItem?.id,
        extra_map:[(-v[1]).toString(), (-v[0]).toString()],
      }, 
      opType: currentType,
      opDescValue: `相对区间${v}天`,
    });
  };
/**
 * 选择时间区间时，去修改父组件的值
 */
  const changeRangeValue = (val,currentType) => {
    let startT;
    let endT;
    startT = val[0] ? moment(val[0]).startOf('days').format('YYYY-MM-DD') : '';
    endT = val[1] ? moment(val[1]).endOf('days').format('YYYY-MM-DD') : '';
    setData([startT,endT]);
    changeData({
      opValue: {
        label_id:tagItem?.id,
        extra_map:[val[0] ? moment(val[0]).startOf('days').format('x') : '',val[1] ? moment(val[1]).endOf('days').format('x') : '']
      } ,
      opType: currentType,
      opDescValue: `区间${startT ? startT : ''}-${endT ? endT: ''}`,
      checkContent: true,
    });
  };
  useEffect(()=>{
    if( pageType ==='1' || (pageType ==='2' && !tagItem.opValue)) { // 如果是创建
      if( tagItem.id === '1111' ||tagItem.id === '2112' || tagItem.id === '2122' || tagItem.id === '2132' || tagItem.id === '2142') {
        // 如果为[近期参加优惠活动人群-下单时间] ||[新客人群客单价-下单时间] || [老客人群客单价-下单时间] || [近期在直播间下单sku-下单时间] || [近期在短视频内下单sku-下单时间]
        changeType('RELRANGE');
        changeRel([0,365],'RELRANGE');
      }
    }else if( pageType === '2') {  
      let startT = tagItem.opValue?.extra_map[0] ? moment(+tagItem.opValue?.extra_map[0]).format('YYYY-MM-DD') : ''
      let endT = tagItem.opValue?.extra_map[1] ? moment(+tagItem.opValue?.extra_map[1]).format('YYYY-MM-DD') : ''
      if(tagItem.opType ==='RANGE') {
        setData([startT,endT])        
      }else if(tagItem.opType === 'RANGEGT') {
        setData([startT,''])
      }else if(tagItem.opType === 'RANGELT') {
        setData(['',startT])
      }
    }
  },[pageType])
  return (
    <div className={`${styles['tag-Time']} tag-width`}>
      <div className={styles['titleBox']}>
        <div style={{color:'#ff3333'}}>*</div>
        <div>
          {tagItem.labelName}
        </div>
        :
        <Select
          followTrigger
          value={type}
          onChange={(val) => changeType(val)}
          className="tag-type-select"
        >
          {
           ( tagItem.id !== '2122' && tagItem.id !== '2112') ?
            sectionType.map((its, ins) => (
              <Select.Option key={`${its.label}${ins}`} value={its.key}>
                {its.label}
              </Select.Option>
            )) :
            sectionType.slice(0,2).map((its, ins) => (
              <Select.Option key={`${its.label}${ins}`} value={its.key}>
                {its.label}
              </Select.Option>
            ))
          }
        </Select>
        {type === 'RANGE' && (
          <>
            <DatePicker.RangePicker
              disabledDate={disabledDate}
              popupAlign="tl bl"
              popupContainer={(target) => target.parentNode}
              hasClear={false}
              format='YYYY-MM-DD'
              value={[data[0],data[1]]}
              onChange={(val) => changeRangeValue(val,type)}
            />
          </>
        )}
        {type === 'RANGEGT' && (
          <DatePicker
            followTrigger
            format="YYYY-MM-DD"
            disabledDate={disabledDate}
            hasClear={false}
            value={data[0]}
            onChange={(val) => changeValue({ opValue: val, index: 0, opType:'RANGEGT' })}
          />
        )}
        {type === 'RANGELT' && (
          <DatePicker
            format="YYYY-MM-DD"
            followTrigger
            disabledDate={disabledDate}
            hasClear={false}
            value={data[1]}
            onChange={(val) => changeValue({ opValue: val, index: 1, opType:'RANGELT' })}
          />
        )}
        {type === 'RELRANGE' && (
          <div className={styles['flex-center']}>
            {/* 由于最后传给后端，是需要把值[1,3]传成 [-3, -1],所以在html结构取值处直接反向显示 */}
            <Range
              className="tag-range-slide"
              slider="double"
              min={0}
              max={365}
              value={[Math.abs(data[1]), Math.abs(data[0])]}
              onChange={(val) => changeRel(val,type)}
            />
            <NumberPicker
              min={0}
              max={Math.abs(365)}
              value={Math.abs(data[1])}
              onChange={(val) =>
                changeRel([
                  val ?? 0,
                  Math.abs(data[0]),
                ],type)
              }
            />
            <span style={{margin:'0 5px'}}> - </span>
            <NumberPicker
              min={0}
              max={Math.abs(365)}
              value={Math.abs(data[0])}
              style={{marginRight:'5px'}}
              onChange={(val) =>
                changeRel([
                  Math.abs(data[1]),
                  val ?? 0,
                ],type)
              }
            />
            {/* <NumberPicker
              min={0}
              max={Math.abs(365)}
              value={Math.abs(data[1])}
              onChange={(val) =>
                changeRel([
                  val ?? 0,
                  Math.abs(data[0]) < val ? val : Math.abs(data[0]),
                ],type)
              }
            />
            <span style={{margin:'0 5px'}}> - </span>
            <NumberPicker
              min={0}
              max={Math.abs(365)}
              value={Math.abs(data[0])}
              style={{marginRight:'5px'}}
              onChange={(val) =>
                changeRel([
                  val ? (Math.abs(data[1]) > val ? val : Math.abs(data[1])) : 0,
                  val ?? 0,
                ],type)
              }
            /> */}
            天
          </div>
        )}
      </div>
      {/* 除新老客外仅支持近一年 */}
      { (tagItem.id !== '2122') && (tagItem.id !== '2112')&& <div style={{color:'#ff3333',paddingTop:'2px'}}>仅支持查询近1年的数据</div>}
      {
        !( type !== 'RANGELT' ? data.every((item) => {return item.toString().length > 0}) : (data.length === 2 ? data[1].toString().length > 0 : data[0].length > 0 ) )
        && <div style={{ color: "#f33", marginTop: "5px" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelName}
        </div>
      }
    </div>
  );
};
export default TagTime;
